import { EBannerTarget, EBannerType } from 'core/model/enums/banners.enum';
import type { TBannerListItemByTarget, TBannerListItemByType } from 'core/model/interfaces/banners';
import type { IBranch, IZone } from 'core/model/interfaces/master-entities';
import type { IBranchDTO, IZoneDTO } from 'core/services/master-entities/master-entities.dto';
import 'dayjs/locale/es';
import { toPriceGroupList } from '../master-entities/master-entities.mappers';
import type { IBannerListItemDTO } from './banners.dto';

export const getBannerByTypeValues = (banner: IBannerListItemDTO): TBannerListItemByType => {
  if (banner.type.id === EBannerType.LOYALTY) {
    return {
      bannerType: {
        typeId: banner.type.id,
        typeName: banner.type.description,
      },
    };
  }

  if (banner.type.id === EBannerType.LINK) {
    return {
      bannerType: {
        typeId: banner.type.id,
        typeName: banner.type.description,
        bannerLinkImageUrl: banner.redirectUrl,
      },
    };
  }

  if (banner.type.id === EBannerType.POPUP) {
    return {
      bannerType: {
        typeId: banner.type.id,
        typeName: banner.type.description,
        popupImageUrl: banner.popupImageUrl as string,
      },
    };
  }

  if (banner.type.id === EBannerType.PROMOTIONAL) {
    return {
      bannerType: {
        typeId: banner.type.id,
        typeName: banner.type.description,
        promotionExternalIds: banner.promotionExternalIds,
      },
    };
  }

  return {
    bannerType: {
      typeId: banner.type.id,
      typeName: banner.type.description,
    },
  };
};

export const getBannerByTargetValues = (banner: IBannerListItemDTO): TBannerListItemByTarget => {
  if (banner.target.id === EBannerTarget.SEGMENT) {
    return {
      bannerTarget: {
        targetId: banner.target.id,
        targetName: banner.target.description,
        zoneList: toBannerZoneList(banner.zones),
        priceGroupList: toPriceGroupList(banner.priceGroups),
        excludedCustomerCodes: banner.excludedExternalCustomerIds,
      },
    };
  }

  if (banner.target.id === EBannerTarget.CUSTOMER_LIST) {
    return {
      bannerTarget: {
        targetId: banner.target.id,
        targetName: banner.target.description,
        customerCodes: banner.externalCustomerIds,
      },
    };
  }

  return {
    bannerTarget: {},
  } as TBannerListItemByTarget;
};

export const toBannerZoneListBranchItem = (branch: IBranchDTO) => {
  const branchItem: IBranch = {
    branchId: branch.id,
    branchName: branch.name,
    distributor: {
      distributorId: branch.distributor.id,
      distributorName: branch.distributor.name,
    },
  };

  return branchItem;
};

export const toBannerZoneList = (zones: Array<IZoneDTO>) => {
  const zoneList: Array<IZone> = zones.map(zone => ({
    zoneId: zone.id,
    zoneName: zone.name,
    branches: zone.branches.map(toBannerZoneListBranchItem),
  }));

  return zoneList;
};
